import React, { Component } from 'react';
import { ReactiveBase, ReactiveList, MultiList, RangeInput, RangeSlider, SelectedFilters } from '@appbaseio/reactivesearch';
import Select from 'react-select';
import moment from 'moment';

// Helpers
import ESCSVExporter from './helpers/ESCSVExporter';

// Components
import SearchBar from './components/SearchBar';
import ResultsTable from './components/ResultsTable';
import SearchToggle from './components/SearchToggle';
import DownloadLink from './components/DownloadLink';

class App extends Component {
  constructor(props) {
    super(props);

    const { esApp, esUrl } = props;

    this.state = {
      results: 0,
      resultsPerPage: {value: 10, label: 10},
      esQuery: { query: { match_all: {} } }, // Default query that gets all items
      sort: 'release_date',
      sortOrder: 'desc',
      yearRangeValue: {start: 1977, end: 2038}
    };

    this.csvExporter = new ESCSVExporter(esApp, esUrl);
    this.onData = this.onData.bind(this);
    this.handleRangeSliderInputChange = this.handleRangeSliderInputChange.bind(this);
    this.updateSort = this.updateSort.bind(this);

    this.reactiveList = React.createRef();
  }

	componentDidMount() {
		window.addEventListener('pushState', this.didUpdateState);
	}

	componentWillUnmount() {
		window.removeEventListener('pushState', this.didUpdateState);
	}

	didUpdateState() {
		// update login links
		const current = '?current=' + encodeURIComponent(window.location.pathname + window.location.search);
		window.jQuery('[data-drupal-link-system-path="user/login"]').each(function() {
			window.jQuery(this).attr('href', '/user/login' + current);
		});
  }

	updateSort(sortBy, sortOrder) {
    this.setState({
      sort: sortBy,
      sortOrder: sortOrder
    })
  }

  onData(data) {
    const { userIsAnonymous } = this.props;
    const { sort, sortOrder } = this.state;

    let columns = [{
      dataField: 'product_name',
      text: window.Drupal.t('Analysis Name'),
      defaultSortOrder: 'asc',
      formatter: (cell, row) => { return (
        <a href={row.path_alias} rel="noopener noreferrer">{cell}</a>
      )},
      headerClasses: (column, colIndex) => {
        return 'wide-column';
      }
    }, {
      dataField: 'short_description',
      text: window.Drupal.t('Description'),
      defaultSortOrder: 'asc',
      formatter: (cell, row) => {
        if(typeof cell !== 'undefined' && cell.length > 0) {
          return cell[0].replace(/(<([^>]+)>)/ig,"");
        }
        return cell;
      },
      headerClasses: (column, colIndex) => {
        return 'wide-column';
      }
    }, {
      dataField: 'manufacturer_name',
      text: window.Drupal.t('Manufacturer'),
      defaultSortOrder: 'asc'
    }, {
      dataField: 'analysis_type_name',
      text: window.Drupal.t('Analysis Type'),
      defaultSortOrder: 'asc'
    }, {
      dataField: 'device_type_name',
      text: window.Drupal.t('Device Type'),
      defaultSortOrder: 'asc'
    }, {
      dataField: 'product_code',
      text: window.Drupal.t('Product Code'),
      defaultSortOrder: 'asc'
    }];

    //if(userIsAnonymous) {
    //  // If user is anonymous, remove the sample report and table of contents
    //  columns = columns.filter(({dataField}) => { return (dataField !== 'sample_report_url' && dataField !== 'toc_url')});
    //}

    return (
      <div className="table-responsive">
        <ResultsTable
          columns={columns}
          rows={ data.results }
          sortBy={sort}
          sortOrder={sortOrder}
          updateSort={this.updateSort}
        />
      </div>
    );
  }

  sensorsToReactTo(component) {
    const { subscriptionTypes } = this.props;
    let sensors = ['Query', 'ItemType', 'AnalysisType', 'DeviceType', 'Manufacturer', 'Channel', 'Date', 'Availability'];

    subscriptionTypes.forEach((type) => {
      sensors.push(type);
    });

    if(typeof component !== 'undefined') {
      sensors = sensors.filter((sensor) => (sensor !== component));
    }

    return sensors;
  }

  handleRangeSliderInputChange(e) {
    console.log(e);
    this.setState({yearRangeValue: e});
  }

  render() {
    const { language, esApp, esUrl, subscriptionTypes } = this.props;
    const { results, resultsPerPage, esQuery, sort, sortOrder } = this.state;

    let resultsPerPageOptions = [
      { value: 10, label: 10 },
      { value: 20, label: 20 },
      { value: 30, label: 30 },
      { value: 40, label: 40 },
      { value: 50, label: 50 },
      { value: 100, label: 100 }
    ];

    const defaultLangQuery = (value, props) => {
      return {
        query: {
          match: {
            _language: language
          }
        }
      }
    };

    let subscriptionIntroText = window.Drupal.t("<p>See what's included in our subscription offerings by using the facets below.</p><hr/><h2>Subscriptions</h2>");

    return (
      <div className="App">
        <ReactiveBase
          app={esApp}
          url={esUrl}
        >
          <div className="product-search-bar">
            <div className="container">
              <div className="row">
                <div className="col">
                  <div className="d-md-flex">
                    <div className="flex-grow-1">
                      <SearchBar
                        dataFields={["product_code", "product_name", "short_description", "long_description", "product_subtype", "manufacturer_name", "device_type_name", "analysis_type_name"]}
                        primaryField="product_name.keyboard"
                        reactSensors={this.sensorsToReactTo('Query')}
                        resultCount={results}
                      />
                    </div>
                    <SearchToggle searchType="products" help={this.props.help}/>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="container-fluid mt-4 mb-4">
            <div className="row">
              <div className="col-xl-3">

                <button type="button" className="tcon tcon-menu--xcross navbar-toggler navbar-toggler-right mb-2" aria-label={window.Drupal.t("Toggle navigation")} data-toggle="collapse" data-target="#FacetNavbar" aria-controls="FacetNavbar" aria-expanded="false">
                  <span className="tcon-menu__lines mr-3"/>
                  <span>{window.Drupal.t("Filter results")}</span>
                </button>
                <div className="collapse navbar-collapse mb-2" id="FacetNavbar">
                  <div className="product-facets accordion borderless" id="facets">

                    <div className="card">
                      <div className="card-header" id="itemTypeFacet">
                        <h2 className="mb-0">
                          <button className="btn btn-link" type="button" data-toggle="collapse"
                                  data-target="#itemTypeCollapse" aria-expanded="false" aria-controls="itemTypeCollapse">
                            {window.Drupal.t("Item Type")}
                          </button>
                        </h2>
                      </div>
                      <div id="itemTypeCollapse" className="collapse" aria-labelledby="itemTypeFacet"
                           data-parent="#facets">
                        <div className="card-body">
                          <MultiList
                            componentId="ItemType"
                            dataField="item_type_name"
                            showCheckbox={true}
                            showCount={false}
                            showSearch={false}
                            sortBy="asc"
                            selectAllLabel={window.Drupal.t("Select All")}
                            queryFormat="or"
                            URLParams={true}
                            filterLabel={window.Drupal.t("Item Type")}
                            react={{
                              and: this.sensorsToReactTo('ItemType')
                            }}
                            size={100}
                          />
                        </div>
                      </div>
                    </div>

                    <div className="card">
                      <div className="card-header" id="analysisTypeFacet">
                        <h2 className="mb-0">
                          <button className="btn btn-link" type="button" data-toggle="collapse"
                                  data-target="#analysisTypeCollapse" aria-expanded="false"
                                  aria-controls="analysisTypeCollapse">
                            {window.Drupal.t("Analysis Type")}
                          </button>
                        </h2>
                      </div>
                      <div id="analysisTypeCollapse" className="collapse" aria-labelledby="analysisTypeFacet"
                           data-parent="#facets">
                        <div className="card-body">
                          <MultiList
                            componentId="AnalysisType"
                            dataField="analysis_type_name"
                            showCheckbox={true}
                            showCount={false}
                            showSearch={false}
                            sortBy="asc"
                            selectAllLabel={window.Drupal.t("Select All")}
                            queryFormat="or"
                            URLParams={true}
                            filterLabel={window.Drupal.t("Analysis Type")}
                            react={{
                                and: this.sensorsToReactTo('AnalysisType')
                            }}
                            size={100}
                          />
                        </div>
                      </div>
                    </div>

                    <div className="card">
                      <div className="card-header" id="deviceTypeFacet">
                        <h2 className="mb-0">
                          <button className="btn btn-link" type="button" data-toggle="collapse"
                                  data-target="#deviceTypeCollapse" aria-expanded="false"
                                  aria-controls="deviceTypeCollapse">
                            {window.Drupal.t("Device Type")}
                          </button>
                        </h2>
                      </div>
                      <div id="deviceTypeCollapse" className="collapse" aria-labelledby="deviceTypeFacet"
                           data-parent="#facets">
                        <div className="card-body">
                          <MultiList
                            componentId="DeviceType"
                            dataField="device_type_name"
                            showCheckbox={true}
                            showCount={false}
                            showSearch={true}
                            sortBy="asc"
                            selectAllLabel={window.Drupal.t("Select All")}
                            queryFormat="or"
                            URLParams={true}
                            filterLabel={window.Drupal.t("Device Type")}
                            react={{
                                and: this.sensorsToReactTo('DeviceType')
                            }}
                            size={2000}
                          />
                        </div>
                      </div>
                    </div>

                    <div className="card">
                      <div className="card-header" id="manufacturerFacet">
                        <h2 className="mb-0">
                          <button className="btn btn-link" type="button" data-toggle="collapse"
                                  data-target="#manufacturerCollapse" aria-expanded="false"
                                  aria-controls="manufacturerCollapse">
                            {window.Drupal.t("Manufacturer")}
                          </button>
                        </h2>
                      </div>
                      <div id="manufacturerCollapse" className="collapse" aria-labelledby="manufacturerFacet"
                           data-parent="#facets">
                        <div className="card-body">
                          <MultiList
                            className="pr-2"
                            componentId="Manufacturer"
                            dataField="manufacturer_name"
                            showCheckbox={true}
                            showCount={false}
                            showSearch={true}
                            sortBy="asc"
                            selectAllLabel={window.Drupal.t("Select All")}
                            queryFormat="or"
                            URLParams={true}
                            filterLabel={window.Drupal.t("Manufacturer")}
                            react={{
                              and: this.sensorsToReactTo('Manufacturer')
                            }}
                            size={2000}
                          />
                        </div>
                      </div>
                    </div>

                    <div className="card">
                      <div className="card-header" id="dateFilter">
                        <h2 className="mb-0">
                          <button className="btn btn-link" type="button" data-toggle="collapse"
                                  data-target="#dateCollapse" aria-expanded="false"
                                  aria-controls="dateCollapse">
                            {window.Drupal.t("Year of Analysis")}
                          </button>
                        </h2>
                      </div>
                      <div id="dateCollapse" className="collapse" aria-labelledby="dateFilter"
                           data-parent="#facets">
                        <div className="card-body">
                            <RangeSlider
                            className="pr-2 year-range-slider"
                            onChange={this.handleRangeSliderInputChange}
                            componentId="Date"
                            dataField="release_date_year"
                            showSlider={true}
                            value={this.state.yearRangeValue}
                            range={{
                              "start": 1977,
                              "end": 2038
                            }}
                            rangeLabels={{
                              "start": "1977",
                              "end": "2038"
                            }}
                            queryFormat="and"
                            showHistogram={true}
                            filterLabel={window.Drupal.t("Date")}
                            react={{
                              and: this.sensorsToReactTo('Date')
                            }}
                          />
                        </div>
                      </div>
                    </div>

                    {/*<div className="card">*/}
                    {/*  <div className="card-header" id="availabilityFacet">*/}
                    {/*    <h2 className="mb-0">*/}
                    {/*      <button className="btn btn-link" type="button" data-toggle="collapse"*/}
                    {/*              data-target="#availabilityCollapse" aria-expanded="false"*/}
                    {/*              aria-controls="availabilityCollapse">*/}
                    {/*        {window.Drupal.t("Availability")}*/}
                    {/*      </button>*/}
                    {/*    </h2>*/}
                    {/*  </div>*/}
                    {/*  <div id="availabilityCollapse" className="collapse" aria-labelledby="availabilityFacet"*/}
                    {/*       data-parent="#facets">*/}
                    {/*    <div className="card-body">*/}
                    {/*      <MultiList*/}
                    {/*        className="pr-2"*/}
                    {/*        componentId="Availability"*/}
                    {/*        dataField="availability"*/}
                    {/*        showCheckbox={true}*/}
                    {/*        showCount={false}*/}
                    {/*        showSearch={false}*/}
                    {/*        sortBy="asc"*/}
                    {/*        selectAllLabel={window.Drupal.t("Select All")}*/}
                    {/*        queryFormat="or"*/}
                    {/*        URLParams={true}*/}
                    {/*        filterLabel={window.Drupal.t("Availability")}*/}
                    {/*        react={{*/}
                    {/*          and: this.sensorsToReactTo('Availability')*/}
                    {/*        }}*/}
                    {/*        size={100}*/}
                    {/*      />*/}
                    {/*    </div>*/}
                    {/*  </div>*/}
                    {/*</div>*/}
                  </div>

                  <div className="card subscription-facets my-3">
                    <div className="card-body">
                      <div className="text-center" dangerouslySetInnerHTML={{__html: subscriptionIntroText}}></div>
                      {subscriptionTypes.map((type, index) => {
                        let component = (type === 'Teardown') ? 'TD' : type;
                        return (
                          <MultiList
                            key={`subscription-${index}`}
                            className="pr-2"
                            componentId={type}
                            dataField="channel_name"
                            showCheckbox={true}
                            showCount={false}
                            showSearch={false}
                            sortBy="asc"
                            selectAllLabel={window.Drupal.t(type)}
                            queryFormat="or"
                            URLParams={true}
                            filterLabel={window.Drupal.t(type)}
                            sortBy="asc"
                            innerClass={{ list: 'indent-items' }}
                            transformData={(data) => {
                              data = data.filter(({key}) => {
                                return key.includes(component + ' -');
                              });
                              return data;
                            }}
                            renderItem={(label, count, isSelected) => {
                              return (
                                <div>{label.replace(component + ' -', '')}</div>
                              )
                            }}
                            react={{
                              and: this.sensorsToReactTo(type)
                            }}
                            size={100}
                            customQuery={(value, props) => {
                              let query = { query: MultiList.defaultQuery(value, props) };
                              if(typeof(value) !== "undefined" && value.length === 1 && value[0] === type) {
                                query = {
                                  "query": {
                                    "bool": {
                                      "must": [
                                        {
                                        "term": {
                                          "subscription_name": type
                                          }
                                        }
                                      ]
                                    }
                                  }
                                }
                              }
                              return query;
                            }}
                          />
                        )
                      })}

                    </div>
                  </div>
                </div>
              </div>
              <div className="col-xl-9">
                <div id="filters-container">
                <SelectedFilters
                  clearAllLabel={window.Drupal.t("Clear filters")}
                />
                </div>
                <ReactiveList
                  ref={this.reactiveList}
                  componentId="SearchResult"
                  dataField={sort}
                  sortBy={sortOrder}
                  size={resultsPerPage.value}
                  renderAllData={this.onData}
                  className="result-list-container"
                  pagination={true}
                  innerClass={{pagination: 'pagination d-flex justify-content-center'}}
                  showResultStats={false}
                  onResultStats={({totalResults}) => { this.setState({results: totalResults}) }}
                  react={{
                    and: this.sensorsToReactTo()
                  }}
                  onQueryChange={(prevQuery, nextQuery) => {
                    var q = "";
                    try {
                      q = nextQuery.query.bool.must["0"].bool.must["0"].query_string.query;
                    } catch (e) {

                    }
                    window.jQuery.ajax('https://w2.techinsights.com/s/4202/Js6qzg5jAIg6c5wvHpOUSrSbqiQDSZ5D', {
                      method: 'POST',
                      xhrFields: {
                        withCredentials: true
                      },
                      crossDomain: true,
                      data: { q: q}
                    });
                    this.setState({esQuery: nextQuery})
                  }}
                />
                <div className="d-flex justify-content-between products-table-actions">
                  <button className="btn btn-primary" onClick={(e) => {e.preventDefault(); this.csvExporter.exportData(esQuery, 'products-' + moment().unix() + '.csv')}}>{window.Drupal.t("Download report listing results")}</button>
                  <Select
                    className="results-per-page"
                    value={resultsPerPage}
                    onChange={(selectedOption) => {
                      if(typeof this.reactiveList != 'undefined') {
                        let newTotalPages = Math.floor(results / selectedOption.value);
                        if(this.reactiveList.current.state.currentPage > newTotalPages) {
                          let self = this;
                          setTimeout(() => {
                            self.reactiveList.current.setPage(newTotalPages);
                          }, 100);

                        }
                      }
                      this.setState({ resultsPerPage: selectedOption });
                    }}
                    options={resultsPerPageOptions}
                  />
                </div>
              </div>
            </div>
          </div>

        </ReactiveBase>
      </div>
    );
  }
}

export default App;
